import { render, staticRenderFns } from "./DictionarySearch.vue?vue&type=template&id=eeaabfca&"
import script from "./DictionarySearch.vue?vue&type=script&lang=js&"
export * from "./DictionarySearch.vue?vue&type=script&lang=js&"
import style0 from "./styles/index.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports